var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoldCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.352,
    x2: 244.285,
    xlinkHref: "#lg1",
    y1: 119.377,
    y2: 163.311
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.422,
    x2: 185.725,
    xlinkHref: "#lg2",
    y1: 135.448,
    y2: 104.75
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.446,
    x2: 264.032,
    xlinkHref: "#lg3",
    y1: 118.222,
    y2: 80.579
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.664,
    x2: 398.052,
    xlinkHref: "#lg1",
    y1: 131.933,
    y2: 202.321
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.412,
    x2: 304.23,
    xlinkHref: "#lg2",
    y1: 157.68,
    y2: 108.498
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.778,
    x2: 465.38,
    xlinkHref: "#lg3",
    y1: 150.92,
    y2: 100.269
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.248,
    x2: 450.881,
    xlinkHref: "#lg1",
    y1: 204.76,
    y2: 313.393
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.986,
    x2: 306.082,
    xlinkHref: "#lg2",
    y1: 244.498,
    y2: 168.593
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.622,
    x2: 584.856,
    xlinkHref: "#lg3",
    y1: 226.98,
    y2: 144.94
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.293,
    x2: 358.979,
    xlinkHref: "#lg1",
    y1: 179.239,
    y2: 311.926
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.829,
    x2: 182.117,
    xlinkHref: "#lg2",
    y1: 227.776,
    y2: 135.064
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.846,
    x2: 473.8,
    xlinkHref: "#lg3",
    y1: 210.658,
    y2: 114.349
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.503,
    x2: 207.186,
    xlinkHref: "#lg1",
    y1: 206.135,
    y2: 355.808
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.769,
    x2: 71.66,
    xlinkHref: "#lg2",
    y1: 231.361,
    y2: 142.252
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -242.977,
    x2: 1278.474,
    xlinkHref: "#lg4",
    y1: 313.538,
    y2: 313.538
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.107,
    x2: 323.107,
    xlinkHref: "#lg4",
    y1: 292.913,
    y2: 195.025
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.708,
    x2: 253.708,
    xlinkHref: "#lg5",
    y1: 355.562,
    y2: 203.395
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.98,
    x2: 252.98,
    xlinkHref: "#lg5",
    y1: 394.717,
    y2: 263.255
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.737,
    x2: 213.775,
    xlinkHref: "#lg5",
    y1: 339.986,
    y2: 72.164
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 186.411,
    y2: 209.904
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.844,
    x2: 256.955,
    xlinkHref: "#lg4",
    y1: 388.852,
    y2: 459.331
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(0 1 1 0 1477.664 -3210.836)",
    gradientUnits: "userSpaceOnUse",
    x1: 3585.874,
    x2: 3948.945,
    xlinkHref: "#lg5",
    y1: -1278.41,
    y2: -879.804
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.712,
    x2: 174.33,
    xlinkHref: "#lg5",
    y1: 473.257,
    y2: 407.875
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.274,
    x2: 408.092,
    xlinkHref: "#lg5",
    y1: 471.069,
    y2: 407.887
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#b5b6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6651,
    stopColor: "#9e96a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.955,
    x2: 205.267,
    xlinkHref: "#lg7",
    y1: 425.813,
    y2: 425.813
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 -1 312.659 784.474)",
    gradientUnits: "userSpaceOnUse",
    x1: 130.556,
    x2: 218.541,
    xlinkHref: "#lg7",
    y1: 358.661,
    y2: 358.661
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8ecf4"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.777,
    x2: 69.441,
    xlinkHref: "#lg8",
    y1: 437.479,
    y2: 357.143
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.639,
    x2: 291.738,
    xlinkHref: "#lg9",
    y1: 428.335,
    y2: 322.448
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.111,
    x2: 138.111,
    xlinkHref: "#lg8",
    y1: 405.16,
    y2: 341.834
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.733,
    x2: 439.045,
    xlinkHref: "#lg7",
    y1: 425.813,
    y2: 425.813
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(-1 0 0 -1 312.659 784.474)",
    gradientUnits: "userSpaceOnUse",
    x1: -103.223,
    x2: -15.238,
    xlinkHref: "#lg7",
    y1: 358.661,
    y2: 358.661
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.555,
    x2: 303.22,
    xlinkHref: "#lg8",
    y1: 437.479,
    y2: 357.143
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.417,
    x2: 525.517,
    xlinkHref: "#lg9",
    y1: 428.335,
    y2: 322.448
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.889,
    x2: 371.889,
    xlinkHref: "#lg8",
    y1: 405.16,
    y2: 341.834
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(1 .002 -.002 1 -4.176 -2.521)",
    gradientUnits: "userSpaceOnUse",
    x1: 128.639,
    x2: 159.802,
    xlinkHref: "#lg6",
    y1: 108.685,
    y2: 150.235
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(1 .002 -.002 1 -4.176 -2.521)",
    gradientUnits: "userSpaceOnUse",
    x1: 401.98,
    x2: 433.143,
    xlinkHref: "#lg6",
    y1: 87.803,
    y2: 129.353
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(1 .002 -.002 1 -4.176 -2.521)",
    gradientUnits: "userSpaceOnUse",
    x1: 91.696,
    x2: 113.733,
    xlinkHref: "#lg6",
    y1: 65.583,
    y2: 94.965
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(1 .002 -.002 1 -4.176 -2.521)",
    gradientUnits: "userSpaceOnUse",
    x1: 165.619,
    x2: 187.656,
    xlinkHref: "#lg6",
    y1: 31.137,
    y2: 60.519
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(1 .002 -.002 1 -4.176 -2.521)",
    gradientUnits: "userSpaceOnUse",
    x1: 343.61,
    x2: 365.647,
    xlinkHref: "#lg6",
    y1: 44.183,
    y2: 73.565
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 213.043,
    cy: 132.069,
    fill: "url(#SVGID_1_)",
    r: 33.921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.043,
    cy: 132.069,
    fill: "url(#SVGID_2_)",
    r: 28.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.217 101.725c2.288 4.566 3.577 9.719 3.577 15.174 0 18.734-15.187 33.921-33.921 33.921-5.455 0-10.608-1.29-15.174-3.577 5.57 11.116 17.064 18.747 30.344 18.747 18.734 0 33.921-15.187 33.921-33.921.001-13.28-7.631-24.775-18.747-30.344z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 347.998,
    cy: 152.267,
    fill: "url(#SVGID_4_)",
    r: 54.347
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.998,
    cy: 152.267,
    fill: "url(#SVGID_5_)",
    r: 45.357
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.309 103.651c3.666 7.315 5.732 15.571 5.732 24.311 0 30.015-24.332 54.347-54.347 54.347-8.739 0-16.995-2.066-24.311-5.732 8.923 17.809 27.34 30.036 48.615 30.036 30.015 0 54.347-24.332 54.347-54.347 0-21.275-12.227-39.692-30.036-48.615z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 373.631,
    cy: 236.143,
    fill: "url(#SVGID_7_)",
    r: 83.876
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.631,
    cy: 236.143,
    fill: "url(#SVGID_8_)",
    r: 70.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.151 161.113c5.657 11.29 8.846 24.032 8.846 37.52 0 46.324-37.553 83.876-83.876 83.876-13.488 0-26.23-3.189-37.52-8.846 13.772 27.485 42.195 46.356 75.03 46.356 46.324 0 83.876-37.553 83.876-83.876 0-32.836-18.871-61.259-46.356-75.03z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 264.624,
    cy: 217.57,
    fill: "url(#SVGID_10_)",
    r: 102.448
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.624,
    cy: 217.57,
    fill: "url(#SVGID_11_)",
    r: 85.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.452 125.927c6.91 13.79 10.805 29.353 10.805 45.828 0 56.581-45.868 102.448-102.449 102.448-16.475 0-32.038-3.895-45.828-10.805 16.821 33.571 51.538 56.62 91.644 56.62 56.581 0 102.448-45.868 102.448-102.448 0-40.105-23.049-74.823-56.62-91.643z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150.96,
    cy: 221.552,
    fill: "url(#SVGID_13_)",
    r: 98.467
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.96,
    cy: 221.552,
    fill: "url(#SVGID_14_)",
    r: 82.179
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.021 215.131-.399 2.349-12.463 73.005-1.95 11.406-13.003 76.212-5.78 33.842h-402.215l-8.457-49.57-11.547-67.661-13.579-79.583z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.622 217.48-12.463 73.005c-23.176 1.633-47.668 2.984-72.194 3.735-53.377 1.609-107 .47-147.76-6.731-51.039-8.998-85.703-21.203-98.613-31.681 9.444-7.858 19.053-14.766 28.814-20.651 14.765-.893 34.476-.564 59.497 1.41 32.35 2.549 67.073 1.962 101.397-.446 50.826-3.582 101.019-11.217 141.322-18.641z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.209 301.891-13.003 76.212-5.779 33.842h-402.216l-8.457-49.571-11.547-67.66c23.446-4.064 45.988-4.957 63.89.071 67.801 19.112 88.311 42.628 147.737 19.112 15.693-6.249 42.288-9.879 73.029-11.852 51.249-3.22 113.729-1.845 156.346-.154z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.206 378.103-5.779 33.842h-402.216l-8.457-49.571c59.79-9.221 151.378-19.593 175.083-1.363 35.545 27.322 54.304 16.75 114.741 1.527 61.07-15.388 34.735 10.678 113.484 15.224 4.686.271 9.056.388 13.144.341z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m489.027 215.131-.411 2.349-12.463 73.005-1.938 11.406-13.004 76.212-5.779 33.842h-238.996l-196.814-196.814z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.655 217.427h-477.31c-9.027 0-16.345-7.318-16.345-16.345 0-9.027 7.318-16.345 16.345-16.345h477.311c9.027 0 16.345 7.318 16.345 16.345-.001 9.027-7.319 16.345-16.346 16.345z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m494.691 443.777v-35.929c0-5.847-4.74-10.587-10.587-10.587h-458.208c-5.847 0-10.587 4.74-10.587 10.587v35.929c0 5.847 4.74 10.587 10.587 10.587h458.208c5.847.001 10.587-4.739 10.587-10.587z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.319 443.971c.065.001.128.01.194.01h458.207c5.847 0 10.587-4.74 10.587-10.587v-35.929c0-.065-.009-.129-.01-.194 5.757.104 10.393 4.795 10.393 10.577v35.929c0 5.847-4.74 10.587-10.587 10.587h-458.207c-5.781.001-10.473-4.636-10.577-10.393z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198.88 397.256 57.121 57.109h-70.363v-57.109z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.63 397.256 53.454 53.442c1.353 1.353.395 3.667-1.518 3.667h-65.177v-57.108h13.241z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 138.111,
    cy: 425.813,
    fill: "url(#SVGID_25_)",
    r: 67.156
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.111,
    cy: 425.813,
    fill: "url(#SVGID_26_)",
    r: 43.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.056 425.813c0 33.107-26.839 59.946-59.946 59.946s-59.945-26.839-59.945-59.946c0-33.106 26.838-59.945 59.945-59.945s59.946 26.838 59.946 59.945z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.151 365.74c4.53 9.04 7.083 19.241 7.083 30.041 0 37.089-30.066 67.156-67.156 67.156-10.799 0-21.001-2.554-30.04-7.083 11.026 22.006 33.783 37.115 60.073 37.115 37.089 0 67.156-30.067 67.156-67.156 0-26.29-15.109-49.047-37.116-60.073z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m183.52 397.072c0 17.233-20.331 31.204-45.409 31.204s-45.409-13.971-45.409-31.204c0-17.234 20.33-31.204 45.409-31.204s45.409 13.97 45.409 31.204z",
    fill: "url(#SVGID_29_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 371.889,
    cy: 425.813,
    fill: "url(#SVGID_30_)",
    r: 67.156
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.889,
    cy: 425.813,
    fill: "url(#SVGID_31_)",
    r: 43.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.835 425.813c0 33.107-26.839 59.946-59.946 59.946s-59.945-26.839-59.945-59.946c0-33.106 26.838-59.945 59.945-59.945s59.946 26.838 59.946 59.945z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.93 365.74c4.53 9.04 7.083 19.241 7.083 30.041 0 37.089-30.066 67.156-67.156 67.156-10.799 0-21.001-2.554-30.04-7.083 11.026 22.006 33.783 37.115 60.073 37.115 37.089 0 67.156-30.067 67.156-67.156-.001-26.29-15.11-49.047-37.116-60.073z",
    fill: "url(#SVGID_33_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m417.298 397.072c0 17.233-20.331 31.204-45.409 31.204s-45.409-13.971-45.409-31.204c0-17.234 20.33-31.204 45.409-31.204s45.409 13.97 45.409 31.204z",
    fill: "url(#SVGID_34_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m161.57 122.33c-9.878 6.437-18.306 14.916-24.689 24.835-1.435 2.23-4.748 2.224-6.175-.011-6.346-9.942-14.743-18.452-24.598-24.925-2.187-1.437-2.181-4.704.011-6.133 9.878-6.437 18.306-14.916 24.689-24.835 1.435-2.231 4.748-2.225 6.175.011 6.347 9.942 14.744 18.452 24.598 24.925 2.188 1.437 2.182 4.704-.011 6.133z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.949 101.94c-9.878 6.437-18.306 14.916-24.689 24.835-1.435 2.23-4.748 2.224-6.175-.011-6.346-9.942-14.743-18.452-24.598-24.925-2.187-1.437-2.181-4.704.011-6.133 9.878-6.437 18.306-14.916 24.689-24.835 1.435-2.23 4.748-2.225 6.175.011 6.347 9.942 14.744 18.452 24.598 24.925 2.188 1.437 2.182 4.704-.011 6.133z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.781 74.495c-6.985 4.552-12.946 10.548-17.459 17.563-1.015 1.577-3.357 1.573-4.367-.008-4.488-7.031-10.426-13.048-17.395-17.626-1.547-1.016-1.543-3.326.008-4.337 6.986-4.552 12.945-10.548 17.459-17.562 1.015-1.577 3.357-1.573 4.367.008 4.488 7.031 10.426 13.048 17.395 17.626 1.547 1.015 1.543 3.326-.008 4.336z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.766 40.182c-6.985 4.552-12.946 10.548-17.459 17.563-1.015 1.577-3.357 1.573-4.367-.008-4.488-7.031-10.426-13.048-17.395-17.626-1.547-1.016-1.543-3.326.008-4.337 6.985-4.552 12.945-10.548 17.459-17.563 1.015-1.577 3.357-1.573 4.367.008 4.488 7.031 10.426 13.048 17.395 17.626 1.547 1.016 1.543 3.327-.008 4.337z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.733 53.548c-6.985 4.552-12.945 10.548-17.459 17.563-1.015 1.577-3.357 1.573-4.367-.008-4.488-7.031-10.426-13.048-17.395-17.626-1.547-1.016-1.543-3.326.008-4.337 6.986-4.552 12.945-10.548 17.459-17.562 1.015-1.577 3.357-1.573 4.367.008 4.488 7.031 10.426 13.048 17.395 17.626 1.547 1.015 1.543 3.326-.008 4.336z",
    fill: "url(#SVGID_39_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoldCart);
export default __webpack_public_path__ + "static/media/icon-gold-cart.d8ad152277a011ad113f2cc3b1e2c8dc.svg";
export { ForwardRef as ReactComponent };